export type ScoreTone = "safe" | "warning" | "danger" | "neutral";

export function getScoreTone(level: string, direction: "netriskscan" | "quality"): ScoreTone {
  if (direction === "netriskscan") {
    // The NetRiskScan Index is cleanliness-oriented: higher bands are safer.
    if (level === "excellent" || level === "good") return "safe";
    if (level === "fair") return "warning";
    if (level === "poor" || level === "high_risk") return "danger";
    return "neutral";
  }

  // Quality grades use their own medium/dangerous vocabulary and must not be conflated with index
  // bands, even though the endpoints share the same visual tones.
  if (level === "excellent" || level === "good") return "safe";
  if (level === "medium") return "warning";
  if (level === "poor" || level === "dangerous") return "danger";
  return "neutral";
}
